import React, { useState } from "react";
import dubai1 from "../assets/images/dubai1.webp";
import emailjs from "@emailjs/browser";

const EMAILJS_SERVICE_ID = "service_3x1mr54";
const EMAILJS_TEMPLATE_ID = "template_auj0cqn";
const EMAILJS_PUBLIC_KEY = "txVJjRtYBet6JGN3H";

const Contact = () => {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    inquiryType: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [submitError, setSubmitError] = useState("");

  // STEPS

  const steps = [
    {
      number: "01",
      title: "Fill out the form",
    },
    {
      number: "02",
      title: "Prepare your questions",
    },
    {
      number: "03",
      title: "Our Relationship Manager will reach out",
    },
    {
      number: "04",
      title: "Let's unlock your business potential!",
    },
  ];

  // FEATURES

  const features = [
    {
      icon: "la-headset",
      title: "24/7 Operational Support",
      description: "We're here to help you.",
    },
    {
      icon: "la-robot",
      title: "Smart AI Automation",
      description: "Boosting travel business efficiency.",
    },
  ];

  // SOLUTIONS

  const solutions = [
    {
      icon: "la-suitcase-rolling",
      title: "B2B Travel Portal",
      description:
        "Easily offer and book the best travel deals for your travelers. Access a wide range of travel services, manage bookings efficiently, and provide competitive deals through one powerful platform.",
      number: "01",
    },
    {
      icon: "la-award",
      title: "Create Your Travel Brand",
      description:
        "Elevate your travel business online with a website and app. Build a strong digital presence, showcase your services, and give your customers a seamless booking experience across every device.",
      number: "02",
    },
    {
      icon: "la-users",
      title: "For Supplier",
      description:
        "Connect, collaborate, and grow with trusted partners. Expand your reach, strengthen business relationships, and unlock new opportunities through a reliable travel technology network.",
      number: "03",
    },
  ];

  // HANDLE INPUT

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setSuccess(false);
    setSubmitError("");
  };

  // VALIDATION

  const validate = () => {
    const newErrors = {};

    const fullName = form.fullName.trim();
    const email = form.email.trim();
    const phone = form.phone.trim();
    const inquiryType = form.inquiryType.trim();

    // Full Name
    if (!fullName) {
      newErrors.fullName = "Full name is required.";
    } else if (fullName.length < 2) {
      newErrors.fullName = "Please enter a valid name.";
    }

    // Email
    if (!email) {
      newErrors.email = "Email address is required.";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    // Phone
    if (!phone) {
      newErrors.phone = "Phone number is required.";
    } else if (!/^[+]?[\d\s()-]{7,20}$/.test(phone)) {
      newErrors.phone = "Please enter a valid phone number.";
    }

    // Inquiry Type
    if (!inquiryType) {
      newErrors.inquiryType = "Please select an services.";
    }

    return newErrors;
  };

  // SUBMIT FORM

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSuccess(false);
    setSubmitError("");

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);

      const firstError = Object.keys(validationErrors)[0];

      setTimeout(() => {
        const element = document.querySelector(`[name="${firstError}"]`);

        if (element) {
          element.focus();

          element.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 50);

      return;
    }

    try {
      setIsSubmitting(true);

      const templateParams = {
        fullName: form.fullName.trim(),
        email: form.email.trim(),
        phone: form.phone.trim(),
        inquiryType: form.inquiryType,
        message: form.message.trim() || "No message provided",
        submittedAt: new Date().toLocaleString(),
      };

      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        templateParams,
        {
          publicKey: EMAILJS_PUBLIC_KEY,
        },
      );

      setSuccess(true);

      setForm({
        fullName: "",
        email: "",
        phone: "",
        inquiryType: "",
        message: "",
      });

      setErrors({});
    } catch (error) {
      console.error("EmailJS Error:", error);

      setSubmitError(
        "Unable to send your inquiry right now. Please try again.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen overflow-hidden bg-[#FEFEFE] text-[#019EE7]">
      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-15px);
          }
        }

        @keyframes floatSlow {
          0%, 100% {
            transform: translate(0px, 0px);
          }
          50% {
            transform: translate(12px, -18px);
          }
        }

        @keyframes pulseGlow {
          0%, 100% {
            opacity: .35;
            transform: scale(1);
          }
          50% {
            opacity: .7;
            transform: scale(1.12);
          }
        }

        @keyframes rotateSlow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes shine {
          0% {
            transform: translateX(-120%);
          }
          50%, 100% {
            transform: translateX(120%);
          }
        }

        @keyframes formFloat {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-8px);
          }
        }
      `}</style>

      {/* =========================================================
          CONTACT HERO / BANNER
      ========================================================= */}
      <section
        className="relative overflow-hidden"
        style={{
          backgroundImage: `
             linear-gradient(120deg, rgb(34 75 139 / 98%) 0%, rgb(0 149 218 / 90%) 50%
50%
, rgb(0 195 230 / 82%) 100%), 
            url(${dubai1})
          `,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-[#019EE7]/20" />

        {/* Premium Glows */}
        <div
          className="absolute -left-48 -top-48 h-[650px] w-[650px] rounded-full bg-[#019EE7]/20 blur-[130px]"
          style={{
            animation: "pulseGlow 7s ease-in-out infinite",
          }}
        />

        <div
          className="absolute -right-40 -top-40 h-[600px] w-[600px] rounded-full bg-[#97BF49]/20 blur-[120px]"
          style={{
            animation: "pulseGlow 8s ease-in-out infinite",
          }}
        />

        <div
          className="absolute -bottom-56 left-[25%] h-[600px] w-[600px] rounded-full bg-[#019EE7]/20 blur-[140px]"
          style={{
            animation: "pulseGlow 9s ease-in-out infinite",
          }}
        />

        {/* Circular Decoration */}
        <div
          className="absolute right-[8%] top-[10%] h-[500px] w-[500px] rounded-full border border-[#FEFEFE]/10"
          style={{
            animation: "rotateSlow 35s linear infinite",
          }}
        />

        <div
          className="absolute right-[13%] top-[17%] h-[380px] w-[380px] rounded-full border border-[#FEFEFE]/10"
          style={{
            animation: "rotateSlow 28s linear infinite reverse",
          }}
        />

        <div className="absolute right-[19%] top-[24%] h-[250px] w-[250px] rounded-full border border-[#97BF49]/20" />

        {/* Floating Dots */}
        <div
          className="absolute left-[8%] top-[22%] h-3 w-3 rounded-full bg-[#97BF49] shadow-[0_0_25px_rgba(151,191,73,0.9)]"
          style={{
            animation: "float 4s ease-in-out infinite",
          }}
        />

        <div
          className="absolute left-[45%] top-[14%] h-2 w-2 rounded-full bg-[#FEFEFE]/60"
          style={{
            animation: "floatSlow 5s ease-in-out infinite",
          }}
        />

        <div
          className="absolute right-[7%] bottom-[20%] h-3 w-3 rounded-full bg-[#97BF49] shadow-[0_0_25px_rgba(151,191,73,0.8)]"
          style={{
            animation: "float 5s ease-in-out infinite",
          }}
        />

        {/* =====================================================
            MAIN HERO CONTENT
        ====================================================== */}
        <div className="relative z-10 mx-auto max-w-7xl px-5 pt-32 pb-12 lg:py-32">
          <div className="items-center flex flex-wrap justify-between">
            {/* LEFT CONTENT */}
            <div className="relative z-10 xl:w-6/12">
              {/* Badge */}
              <div className="mb-4 inline-flex items-center gap-3 rounded-full border border-[#FEFEFE]/20 bg-[#FEFEFE]/10 px-4 py-2 shadow-[0_10px_40px_rgba(1,158,231,0.18)] backdrop-blur-xl">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#97BF49] text-base font-bold text-[#FEFEFE] shadow-[0_0_20px_rgba(151,191,73,0.55)]">
                  ✦
                </span>

                <span className="text-sm font-semibold uppercase tracking-[2px] text-[#FEFEFE] sm:text-sm">
                  Let's Connect
                </span>
              </div>

              {/* Heading */}
              <h1 className="max-w-[700px] text-[45px] font-black leading-[0.98] tracking-[-2px] text-[#FEFEFE] sm:text-[64px] md:text-[74px] lg:text-[78px]">
                Connect With Us
                <br />
                <span className="bg-gradient-to-r from-[#97BF49] via-[#97BF49] to-[#FEFEFE] bg-clip-text text-transparent">
                  Today
                </span>
              </h1>

              {/* Description */}
              <p className="mt-3 max-w-[650px] text-[17px] font-medium leading-8 text-[#fff] sm:text-[19px] sm:leading-9">
                Have Questions? We've Got Answers. Tell us about your travel
                business and our experts will help you find the right solution.
              </p>

              {/* Steps */}
              <div className="mt-4 grid max-w-[720px] grid-cols-1 gap-x-10 gap-y-6 sm:grid-cols-2">
                {steps.map((step) => (
                  <div
                    key={step.number}
                    className="group flex items-start gap-4"
                  >
                    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-[#FEFEFE]/20 bg-[#FEFEFE]/10 text-[14px] font-bold text-[#97BF49] shadow-lg backdrop-blur-xl transition duration-300 group-hover:border-[#97BF49] group-hover:bg-[#97BF49] group-hover:text-[#FEFEFE]">
                      {step.number}
                    </div>

                    <p className="pt-1 text-[15px] font-semibold leading-6 text-[#FEFEFE]/90 sm:text-[16px]">
                      {step.title}
                    </p>
                  </div>
                ))}
              </div>

              {/* Divider */}
              <div className="my-6 max-w-[700px] border-t border-[#FEFEFE]/15" />

              {/* Features */}
              <div className="grid max-w-[720px] grid-cols-1 gap-x-10 gap-y-7 sm:grid-cols-2">
                {features.map((feature) => (
                  <div
                    key={feature.title}
                    className="group flex items-start gap-4"
                  >
                    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-[#FEFEFE]/10 bg-[#FEFEFE]/10 text-[#FEFEFE] shadow-lg backdrop-blur-xl transition duration-300 group-hover:-translate-y-1 group-hover:bg-[#97BF49]">
                      <i className={`las ${feature.icon} text-[25px]`} />
                    </div>

                    <div>
                      <h3 className="text-[16px] font-bold text-[#FEFEFE] sm:text-[17px]">
                        {feature.title}
                      </h3>

                      <p className="mt-1 text-[13px] leading-5 text-[#FEFEFE]/60 sm:text-[14px]">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* =================================================
                GLASS FORM
            ================================================= */}
            <div
              className="relative z-20 xl:w-6/12 md:pl-12 w-full md:pt-0 pt-12"
              style={{
                animation: "formFloat 6s ease-in-out infinite",
              }}
            >
              {/* Glass Card */}
              <div className="relative overflow-hidden rounded-[28px] border border-[#FEFEFE]/30 bg-[#FEFEFE]/15 p-5 shadow-[0_30px_90px_rgba(1,158,231,0.28)] backdrop-blur-[28px] sm:p-7">
                <div className="pointer-events-none absolute -left-[100%] top-0 h-full w-[45%] rotate-[15deg] bg-gradient-to-r from-transparent via-[#FEFEFE]/15 to-transparent" />

                <div className="pointer-events-none absolute -right-24 -top-24 h-48 w-48 rounded-full bg-[#97BF49]/20 blur-[60px]" />

                {/* Form Header */}
                <div className="relative mb-6">
                  <div className="flex items-center gap-3">
                    <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-[#FEFEFE]/20 bg-[#FEFEFE]/15 text-[#FEFEFE] shadow-lg backdrop-blur-xl">
                      <i className="las la-paper-plane text-[28px]" />
                    </div>

                    <div>
                      <h2 className="text-[24px] font-extrabold text-[#FEFEFE] sm:text-[26px]">
                        Let's Transform
                      </h2>

                      <p className="mt-0.5 text-[14px] font-semibold text-[#fff] sm:text-[15px]">
                        Your Travel Business
                      </p>
                    </div>
                  </div>
                </div>

                {/* =================================================
                    CONTACT FORM
                ================================================= */}
                <form
                  onSubmit={handleSubmit}
                  className="relative space-y-4"
                  noValidate
                >
                  {/* SUCCESS MESSAGE */}
                  {success && (
                    <div className="rounded-xl border border-[#97BF49]/40 bg-[#97BF49]/15 px-4 py-3 text-sm font-semibold text-white">
                      Thank you! Your inquiry has been sent successfully. Our
                      team will contact you shortly.
                    </div>
                  )}

                  {/* ERROR MESSAGE */}
                  {submitError && (
                    <div className="rounded-xl border border-red-300/40 bg-red-500/15 px-4 py-3 text-sm font-semibold text-white">
                      {submitError}
                    </div>
                  )}

                  {/* Name */}
                  <div className="grid grid-cols-1 gap-3 sm:grid-cols-1">
                    <div>
                      <label className="mb-1.5 block text-base font-medium text-white">
                        Full Name <span className="text-[#fff]">*</span>
                      </label>

                      <input
                        type="text"
                        name="fullName"
                        value={form.fullName}
                        onChange={handleChange}
                        placeholder="Full name"
                        className={`h-[50px] w-full rounded-xl border ${
                          errors.fullName
                            ? "border-red-400"
                            : "border-[#FEFEFE]/20"
                        } bg-[#FEFEFE]/10 px-3.5 text-[14px] text-[#FEFEFE] outline-none backdrop-blur-xl transition placeholder:text-[#FEFEFE]/45 focus:border-[#97BF49] focus:bg-[#FEFEFE]/15 focus:ring-2 focus:ring-[#97BF49]/20`}
                      />

                      {errors.fullName && (
                        <p className="mt-1.5 text-[12px] font-medium text-red-200">
                          {errors.fullName}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Email + Phone */}
                  <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                    <div>
                      <label className="mb-1.5 block text-base font-medium text-white">
                        Email Address <span className="text-[#fff]">*</span>
                      </label>

                      <input
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        placeholder="name@example.com"
                        className={`h-[50px] w-full rounded-xl border ${
                          errors.email
                            ? "border-red-400"
                            : "border-[#FEFEFE]/20"
                        } bg-[#FEFEFE]/10 px-3.5 text-[14px] text-[#FEFEFE] outline-none backdrop-blur-xl transition placeholder:text-[#FEFEFE]/45 focus:border-[#97BF49] focus:bg-[#FEFEFE]/15 focus:ring-2 focus:ring-[#97BF49]/20`}
                      />

                      {errors.email && (
                        <p className="mt-1.5 text-[12px] font-medium text-red-200">
                          {errors.email}
                        </p>
                      )}
                    </div>

                    <div>
                      <label className="mb-1.5 block text-base font-medium text-white">
                        Phone Number <span className="text-[#fff]">*</span>
                      </label>

                      <input
                        type="tel"
                        name="phone"
                        value={form.phone}
                        onChange={handleChange}
                        placeholder="Mobile Number"
                        className={`h-[50px] w-full rounded-xl border ${
                          errors.phone
                            ? "border-red-400"
                            : "border-[#FEFEFE]/20"
                        } bg-[#FEFEFE]/10 px-3.5 text-[14px] text-[#FEFEFE] outline-none backdrop-blur-xl transition placeholder:text-[#FEFEFE]/45 focus:border-[#97BF49] focus:bg-[#FEFEFE]/15 focus:ring-2 focus:ring-[#97BF49]/20`}
                      />

                      {errors.phone && (
                        <p className="mt-1.5 text-[12px] font-medium text-red-200">
                          {errors.phone}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Inquiry */}
                  <div>
                    <label className="mb-1.5 block text-base font-medium text-white">
                      Services <span className="text-[#fff]">*</span>
                    </label>

                    <select
                      name="inquiryType"
                      value={form.inquiryType}
                      onChange={handleChange}
                      className={`h-[50px] w-full rounded-xl border ${
                        errors.inquiryType
                          ? "border-red-400"
                          : "border-[#FEFEFE]/20"
                      } bg-[#FEFEFE]/10 px-3.5 text-[14px] ${
                        form.inquiryType
                          ? "text-[#FEFEFE]"
                          : "text-[#FEFEFE]/65"
                      } outline-none backdrop-blur-xl transition focus:border-[#97BF49] focus:bg-[#FEFEFE]/15 focus:ring-2 focus:ring-[#97BF49]/20`}
                    >
                      <option
                        value=""
                        disabled
                        className="bg-[#FEFEFE] text-[#374151]"
                      >
                        Select Services
                      </option>

                      <option
                        value="Global Airlines Ticketing"
                        className="bg-[#FEFEFE] text-[#374151]"
                      >
                        Global Airlines Ticketing
                      </option>

                      <option
                        value="Worldwide Hotel Accommodation"
                        className="bg-[#FEFEFE] text-[#374151]"
                      >
                        Worldwide Hotel Accommodation
                      </option>

                      <option
                        value="Outbound Holiday Packages"
                        className="bg-[#FEFEFE] text-[#374151]"
                      >
                        Outbound Holiday Packages
                      </option>

                      <option
                        value="Global Visa Assistance"
                        className="bg-[#FEFEFE] text-[#374151]"
                      >
                        Global Visa Assistance
                      </option>

                      <option
                        value="Transfers & Train Tickets"
                        className="bg-[#FEFEFE] text-[#374151]"
                      >
                        Transfers & Train Tickets
                      </option>
                      <option
                        value="Travel Insurance"
                        className="bg-[#FEFEFE] text-[#374151]"
                      >
                        Travel Insurance
                      </option>
                      <option
                        value="UAE Tourist Visa"
                        className="bg-[#FEFEFE] text-[#374151]"
                      >
                        UAE Tourist Visa
                      </option>
                      <option
                        value="24/7 Client Assistance"
                        className="bg-[#FEFEFE] text-[#374151]"
                      >
                        24/7 Client Assistance
                      </option>
                    </select>

                    {errors.inquiryType && (
                      <p className="mt-1.5 text-[12px] font-medium text-red-200">
                        {errors.inquiryType}
                      </p>
                    )}
                  </div>

                  {/* Message */}
                  <div>
                    <label className="mb-1.5 block text-base font-medium text-white">
                      Message
                    </label>

                    <textarea
                      name="message"
                      value={form.message}
                      onChange={handleChange}
                      rows="2"
                      placeholder="Write your message here..."
                      className="min-h-[40px] w-full resize-none rounded-xl border border-[#FEFEFE]/20 bg-[#FEFEFE]/10 px-3.5 py-3 text-[14px] leading-5 text-[#FEFEFE] outline-none backdrop-blur-xl transition placeholder:text-[#FEFEFE]/45 focus:border-[#97BF49] focus:bg-[#FEFEFE]/15 focus:ring-2 focus:ring-[#97BF49]/20"
                    />
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`group relative flex h-[58px] w-full items-center justify-center gap-3 overflow-hidden rounded-lg bg-[#97bf49] text-[18px] font-extrabold tracking-[0.5px] text-[#fff] transition-all duration-500 ${
                      isSubmitting
                        ? "cursor-not-allowed opacity-70"
                        : "hover:-translate-y-1 hover:scale-[1.01] hover:bg-[#0188C8]"
                    }`}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="relative z-10 h-5 w-5 animate-spin rounded-full border-2 border-white/30 border-t-white" />

                        <span className="relative z-10">Sending...</span>
                      </>
                    ) : (
                      <>
                        <span className="relative z-10">Let's Connect</span>

                        <span className="relative z-10 flex h-8 w-8 items-center justify-center rounded-full bg-[#FEFEFE]/20">
                          <i className="las la-arrow-right text-[20px] transition-all duration-300 group-hover:translate-x-1" />
                        </span>
                      </>
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================================
          SOLUTIONS SECTION
      ========================================================= */}
      <section className="relative bg-[#FEFEFE] py-12 lg:py-16">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
          {/* Heading */}
          <div className="mx-auto max-w-[800px] md:text-center text-left">
            <span className="inline-block text-base font-bold tracking-[0.2em] text-[#007FC0]">
              Our Solutions
            </span>

            <h2 className="text-[25px] font-semibold text-[#12344A] md:text-[46px] md:text-center text-left leading-[1.1] tracking-[0.2px] md:mt-5 mt-2">
              Global Tech Solution for
              <br />
              <span className="text-[#12344A]">Smarter Travel Agents</span>
            </h2>

            <p className="mx-auto md:mt-5 mt-3 max-w-[650px] text-[16px] leading-7 text-[#737D84] sm:text-[17px]">
              Transform your travel business today with our technology-driven
              solutions and travel expertise.
            </p>
          </div>

          {/* Cards */}
          <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
            {solutions.map((solution) => (
              <div
                key={solution.number}
                className="group relative overflow-hidden rounded-[22px] border border-[#9BC5E0]/60 bg-[#FEFEFE] p-6 shadow-[0_10px_35px_rgba(1,158,231,0.05)] transition duration-300 hover:-translate-y-2 hover:shadow-[0_20px_50px_rgba(1,158,231,0.11)]"
              >
                <div className="absolute -right-16 -top-16 h-40 w-40 rounded-full bg-[#019EE7]/5 blur-3xl transition duration-500 group-hover:bg-[#019EE7]/10" />

                <div className="relative flex items-start justify-between">
                  <button
                    type="button"
                    className="group relative flex h-[66px] w-[66px] items-center justify-center rounded-full shadow-[0_8px_20px_rgba(1,158,231,0.10)] transition-all duration-500 hover:scale-110"
                  >
                    <div className="absolute inset-0 scale-75 rounded-full bg-[#019EE7]/15 opacity-0 blur-xl transition-all duration-500 group-hover:scale-125 group-hover:opacity-70" />

                    <div className="relative flex h-[54px] w-[54px] items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-[#9BC5E0] via-[#019EE7] to-[#0066A1] shadow-[0_6px_15px_rgba(1,158,231,0.30)] transition-all duration-500">
                      <span className="absolute left-[8px] top-[6px] h-[7px] w-[20px] rotate-[-25deg] rounded-full bg-[#FEFEFE]/50 blur-[1px]" />

                      <span className="absolute right-[-4px] top-[-4px] h-[22px] w-[22px] rounded-full bg-[#FEFEFE]/20 blur-md" />

                      <i
                        className={`las ${solution.icon} relative z-10 text-[28px] font-bold text-[#FEFEFE] transition-all duration-300 group-hover:scale-110`}
                      />
                    </div>
                  </button>

                  <span className="text-[14px] font-bold tracking-[1px] text-[#9BC5E0]">
                    {solution.number}
                  </span>
                </div>

                <h3 className="relative mt-4 text-[20px] font-extrabold text-[#12344A]">
                  {solution.title}
                </h3>

                <p className="relative mt-2 text-base leading-6 text-[#374151]">
                  {solution.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =========================================================
          OFFICE SECTION
      ========================================================= */}
      <section className="relative overflow-hidden bg-[#FEFEFE] py-2 lg:pb-24 lg:pt-12">
        <div className="absolute left-[-180px] top-[-150px] h-[450px] w-[450px] rounded-full bg-[#019EE7]/8 blur-[100px]" />

        <div className="absolute right-[-180px] bottom-[-150px] h-[450px] w-[450px] rounded-full bg-[#97BF49]/10 blur-[100px]" />

        <div className="relative mx-auto max-w-6xl px-5 sm:px-8">
          {/* Heading */}
          <div className="md:text-center text-left">
            <span className="inline-block text-base font-bold tracking-[0.2em] text-[#007FC0]">
              Visit Our Office
            </span>

            <h2 className="text-[25px] font-semibold text-[#12344A] md:text-[46px] md:text-center text-left leading-[1.1] tracking-[0.2px] mt-3">
              Find Us <span className="text-[#20252B]">Here</span>
            </h2>

            <p className="mx-auto mt-2 max-w-[600px] text-[17px] leading-7 text-[#737D84]">
              We're here to help you build, grow and transform your travel
              business.
            </p>
          </div>

          {/* SINGLE BRANCH */}
          <div className="mx-auto md:mt-12 mt-6 max-w-[1050px] overflow-hidden rounded-[28px] border border-[#9BC5E0]/60 bg-[#FEFEFE] shadow-[0_25px_70px_rgba(1,158,231,0.10)]">
            <div className="grid grid-cols-1 lg:grid-cols-[0.8fr_1.2fr]">
              {/* Left Dark Panel */}
              <div className="relative overflow-hidden bg-gradient-to-r from-[#224b8b] via-[#0095DA] to-[#00c3e6] p-4 sm:p-12">
                <div className="absolute -right-24 -top-24 h-56 w-56 rounded-full bg-[#97BF49]/25 blur-[70px]" />

                <div className="absolute -bottom-20 -left-20 h-52 w-52 rounded-full bg-[#FEFEFE]/15 blur-[70px]" />

                <div className="absolute right-[-90px] top-[35%] h-[220px] w-[220px] rounded-full border border-[#FEFEFE]/10" />

                <div className="relative">
                  <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#97BF49] text-[#FEFEFE] shadow-[0_10px_25px_rgba(151,191,73,0.30)]">
                    <i className="las la-building text-[29px]" />
                  </div>

                  <p className="mt-8 text-[12px] font-bold uppercase tracking-[2px] text-[#FEFEFE]">
                    Corporate Office
                  </p>

                  <h3 className="mt-3 text-[30px] font-extrabold leading-tight text-[#FEFEFE] sm:text-[34px]">
                    Your Travel
                    <br />
                    Business Partner
                  </h3>

                  <div className="mt-7 h-1 w-14 rounded-full bg-[#97BF49]" />

                  <p className="mt-7 max-w-[330px] text-[14px] leading-7 text-[#FEFEFE]/75">
                    Connect with our team for travel technology, B2B solutions,
                    holiday packages and business growth opportunities.
                  </p>

                  <div className="mt-10 flex items-center gap-3">
                    <div className="flex h-11 w-11 items-center justify-center rounded-full border border-[#FEFEFE]/10 bg-[#FEFEFE]/10 text-[#FEFEFE]">
                      <i className="las la-globe text-[20px]" />
                    </div>

                    <span className="text-[13px] font-semibold text-[#FEFEFE]/75">
                      Serving travel businesses globally
                    </span>
                  </div>
                </div>
              </div>

              {/* Right Address */}
              <div className="p-4 sm:p-12">
                <div className="flex items-start gap-4">
                  <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-[#019EE7]/10 text-[#019EE7]">
                    <i className="las la-map-marker text-[26px]" />
                  </div>

                  <div>
                    <p className="text-[11px] font-bold uppercase tracking-[2px] text-[#97BF49]">
                      Visit Us
                    </p>

                    <h3 className="mt-1 text-[25px] font-semibold text-[#12344A]">
                      Our Location
                    </h3>
                  </div>
                </div>

                {/* Address */}
                <div className="mt-8 rounded-2xl border border-[#9BC5E0]/60 bg-[#FEFEFE] p-5">
                  <div className="flex gap-4">
                    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#97BF49]/10 text-[#97BF49]">
                      <i className="las la-building text-[23px]" />
                    </div>

                    <div>
                      <p className="text-[11px] font-bold uppercase tracking-[1.5px] text-[#9BC5E0]">
                        Office Address
                      </p>

                      <p className="mt-2 text-[15px] font-semibold leading-6 text-[#374151]">
                        1606, Blue Bay Tower,
                        <br />
                        Business Bay, Dubai – UAE
                      </p>
                    </div>
                  </div>
                </div>

                {/* Office Hours */}
                <div className="mt-4 flex items-center gap-4 rounded-2xl border border-[#9BC5E0]/60 bg-[#FEFEFE] p-4">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#97BF49]/10 text-[#97BF49]">
                    <i className="las la-headset text-[23px]" />
                  </div>

                  <div>
                    <p className="text-[11px] font-bold uppercase tracking-[1.5px] text-[#9BC5E0]">
                      Quick Support
                    </p>

                    <p className="mt-1 text-[14px] font-bold text-[#374151]">
                      We’re Here to Help
                    </p>

                    <p className="mt-0.5 text-[12px] text-[#374151]">
                      Get assistance whenever you need
                    </p>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="mt-5 grid grid-cols-3 gap-3">
                  {/* Location */}
                  <a
                    href="https://maps.app.goo.gl/PY5uEv4kq9mUqaUo9"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group relative flex flex-col items-center justify-center rounded-2xl border border-[#9BC5E0]/60 bg-[#FEFEFE] py-4 transition-all duration-500 hover:-translate-y-1"
                  >
                    <div className="absolute inset-0 rounded-2xl bg-[#019EE7]/10 opacity-0 blur-xl transition-all duration-500 group-hover:opacity-100" />

                    <div className="relative flex h-12 w-12 items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-[#9BC5E0] to-[#019EE7] shadow-[0_6px_15px_rgba(1,158,231,0.25)]">
                      <span className="absolute left-[6px] top-[5px] h-[5px] w-[15px] rotate-[-25deg] rounded-full bg-[#FEFEFE]/50" />

                      <i className="las la-map-marker relative z-10 text-[23px] text-[#FEFEFE]" />
                    </div>

                    <span className="relative mt-2 text-[12px] font-bold text-[#374151]">
                      Location
                    </span>
                  </a>

                  {/* WhatsApp */}
                  <a
                    href="https://wa.me/971565443990"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group relative flex flex-col items-center justify-center rounded-2xl border border-[#9BC5E0]/60 bg-[#FEFEFE] py-4 transition-all duration-500 hover:-translate-y-1"
                  >
                    <div className="absolute inset-0 rounded-2xl bg-[#019EE7]/10 opacity-0 blur-xl transition-all duration-500 group-hover:opacity-100" />

                    <div className="relative flex h-12 w-12 items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-[#9BC5E0] to-[#019EE7] shadow-[0_6px_15px_rgba(1,158,231,0.25)]">
                      <span className="absolute left-[6px] top-[5px] h-[5px] w-[15px] rotate-[-25deg] rounded-full bg-[#FEFEFE]/50" />

                      <i className="lab la-whatsapp relative z-10 text-[23px] text-[#FEFEFE]" />
                    </div>

                    <span className="relative mt-2 text-[12px] font-bold text-[#374151]">
                      WhatsApp
                    </span>
                  </a>

                  {/* Email */}
                  <a
                    href="mailto:info@voyageplustravel.com"
                    className="group relative flex flex-col items-center justify-center rounded-2xl border border-[#9BC5E0]/60 bg-[#FEFEFE] py-4 transition-all duration-500 hover:-translate-y-1"
                  >
                    <div className="absolute inset-0 rounded-2xl bg-[#019EE7]/10 opacity-0 blur-xl transition-all duration-500 group-hover:opacity-100" />

                    <div className="relative flex h-12 w-12 items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-[#9BC5E0] to-[#019EE7] shadow-[0_6px_15px_rgba(1,158,231,0.25)]">
                      <span className="absolute left-[6px] top-[5px] h-[5px] w-[15px] rotate-[-25deg] rounded-full bg-[#FEFEFE]/50" />

                      <i className="las la-envelope relative z-10 text-[23px] text-[#FEFEFE]" />
                    </div>

                    <span className="relative mt-2 text-[12px] font-bold text-[#374151]">
                      Email
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================================
          CTA
      ========================================================= */}
      <section className="relative mx-auto max-w-7xl px-5 pb-10 pt-12 sm:px-8 md:pt-0 lg:px-10">
        <div className="relative overflow-hidden rounded-[25px] bg-gradient-to-r from-[#224b8b] via-[#0095DA] to-[#00c3e6] px-6 py-14 text-center shadow-[0_25px_70px_rgba(1,158,231,0.22)] sm:px-12 sm:py-16">
          {/* Glows */}
          <div className="absolute -left-20 -top-20 h-56 w-56 rounded-full bg-[#97BF49]/15 blur-[60px]" />

          <div className="absolute -right-20 -bottom-20 h-64 w-64 rounded-full bg-[#019EE7]/30 blur-[70px]" />

          {/* Circles */}
          <div className="absolute -left-16 top-1/2 h-44 w-44 -translate-y-1/2 rounded-full border-[25px] border-[#FEFEFE]/5" />

          <div className="absolute -right-20 top-1/2 h-56 w-56 -translate-y-1/2 rounded-full border-[30px] border-[#FEFEFE]/5" />

          <div className="relative">
            <span className="inline-block text-base font-bold tracking-[0.2em] text-[#fff]">
              Take The Next Step
            </span>

            <h2 className="mx-auto mt-3 max-w-[700px] text-[36px] font-semibold leading-[1.1] tracking-[0.2px] text-[#fff] md:text-[46px]">
              Ready to Upgrade Your
              <br />
              <span className="text-[#fff]">Travel Business?</span>
            </h2>

            <p className="mx-auto mt-5 max-w-[650px] text-[15px] leading-7 text-[#FEFEFE]/75 sm:text-[16px]">
              Say goodbye to manual work, simplify your booking process and grow
              your business with smart automation.
            </p>

            <p className="mt-5 text-[12px] font-medium text-[#FEFEFE]/60">
              Don't wait. Transform your business into a strong brand.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
